<template lang="pug">
  app-focus-lock
    el-dialog(
      :visible="dialogVisible"
      :title="`${formTitle} Team`"
      :close-on-click-modal="false"
      v-on:update:visible="closeDialog"
      top="5vh" width="100%"
    ).el-dialog__max-w-700.mx-auto.px-3.px-lg-0
      el-form(
        :model="editedItem"
        status-icon
        ref="form"
        label-position="top"
        :rules="rules"
      )
        .row.mb-3
          el-form-item(label="Team Name" prop="name").col-sm-12
            el-input(v-model="editedItem.name")

          .col-md-6(:class="{ 'preview-selected-input': editedItem.icon }")
            .pin.pin-icon
              font-awesome-icon(v-if="editedItem.icon" :icon="['fal', editedItem.icon]")
            el-form-item(label="Team Icon" prop="icon")
              el-select(v-model="editedItem.icon" placeholder="Select").w-100
                .p-2.max-w-320.clearfix
                  el-option(
                    v-for="(item, index) in loockups.teamIcons",
                    :key="index" :value="item"
                  ).size-48.float-left.px-0.d-flex
                    font-awesome-icon(:icon="['fal', item]" size="2x").m-auto

          .col-md-6(:class="{ 'preview-selected-input': editedItem.color }")
            .pin.pin-color
              .size-18(:style="{ backgroundColor: editedItem.color }")
            el-form-item(label="Team Color" prop="color")
              el-select(v-model="editedItem.color" placeholder="Select").w-100
                .p-2.max-w-320.clearfix
                  el-option(
                      v-for="(item, index) in loockups.teamColors",
                      :key="index" :value="item"
                    ).size-48.float-left.px-0.d-flex
                      .size-42.m-auto.d-flex(:style="{ backgroundColor: item }")
                        font-awesome-icon(
                          v-if="editedItem.color === item"
                          :icon="['fal', 'check']" size="2x"
                        ).m-auto.text-white

      .dialog-footer(slot="footer")
        .row
          .col-auto(v-if="!isNew")
            el-button(@click="$emit('delete-item')") Delete Team
          .col
            el-button(@click="closeDialog") Cancel
            el-button(type="primary" @click="validateForm('form')"  v-loading="loading")
              template(v-if="isNew") Save
              template(v-else) Update
</template>

<script>
import { teamIcons, teamColors } from '@/data/lookups';

export default {
  name: 'DialogAddEditTeam',

  props: {
    formTitle: { type: String, default: '' },
    editedItem: { type: Object, default: () => { } },
    dialogVisible: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      loockups: { teamIcons, teamColors },

      reSendingEmail: false,

      rules: {
        name: { required: true, message: 'Name is required', trigger: 'change' },
        icon: { required: true, message: 'Name is required', trigger: 'change' },
        color: { required: true, message: 'Name is required', trigger: 'change' },
      },
    };
  },

  computed: {
    isNew() {
      return this.formTitle === 'Add';
    },
  },

  methods: {
    submitForm() {
      this.$emit('save-item');
    },

    closeDialog() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close-dialog');
    },

    validateForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) return this.submitForm();
        console.log('error submit!!');
        return false;
      });
    },
  },
};
</script>
